import { 
    page
} from '@/api/ad-unit-general.js'

export default {
  state: {
    list: [],
    pageNum: 1,
    pageSize: 10,
    total: 0,
    adUnitGeneralLoading: false
  },
  mutations: {
    setList (state, list) {
      state.list = list
    },
    setAdUnitGeneralLoading (state, loading) {
      state.adUnitGeneralLoading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    },
  },
  getters: {
    adUnitGeneralList: state => state.list,
    adUnitGeneralTotal: state => state.total,
    adUnitGeneralLoading: state => state.adUnitGeneralLoading
  },
  actions: {
    getAdUnitGeneralPage ({ state, commit }, param) {
      commit('setAdUnitGeneralLoading', true)
      return new Promise((resolve, reject) => {
        page(param).then(res => {
          const data = res.data.result
          const list = data.records
          const total = data.total
          const pageNum = data.pageNum
          const pageSize = data.pageSize
          commit('setList', list)
          commit('setTotal', total)
          commit('setPageNum', pageNum)
          commit('setPageSize', pageSize)
          commit('setAdUnitGeneralLoading', false)
          resolve()
        }).catch(err => {
          commit('setAdUnitGeneralLoading', false)
          reject(err)
        })
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/module/ad-unit-general.js